import { Button } from "@package/subframe/components/Button";
import { IconWithLogoBackground } from "@package/subframe/components/IconWithLogoBackground";
import { LinkButton } from "@package/subframe/components/LinkButton";
import { FeatherArrowLeft, FeatherFileQuestion } from "@subframe/core";
import { Link } from "@tanstack/react-router";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-default-background p-4">
      <div className="flex w-full max-w-[384px] flex-col items-center gap-6">
        {/* Icon */}
        <IconWithLogoBackground
          variant="neutral"
          size="x-large"
          icon={<FeatherFileQuestion />}
        />

        {/* Header */}
        <div className="flex w-full flex-col items-center gap-2">
          <span className="text-heading-1 font-heading-1 text-default-font">
            Page not found
          </span>
          <span className="text-body font-body text-subtext-color text-center">
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </span>
        </div>

        {/* Actions */}
        <div className="flex w-full flex-col items-center gap-4">
          <Link to="/dashboard" className="w-full">
            <Button className="h-12 w-full" variant="brand-primary" size="large">
              Go to Dashboard
            </Button>
          </Link>
          <Link to="/">
            <LinkButton
              variant="neutral"
              size="medium"
              icon={<FeatherArrowLeft />}
            >
              Back to Home
            </LinkButton>
          </Link>
        </div>
      </div>
    </div>
  );
}
